module.exports = __webpack_public_path__ + "img/cash_nl10.af2ba513.png";